import React, { lazy, Suspense } from "react";
import { Form, Row } from "antd";
import { Loading } from "../Loading";

import SearchGroups from "./SearchGroups";

export interface SearchControlsPropsI {
  groups: any[];
  form: any;
  onSubmit: Function;
  onReset?: Function;
  numberOfControls: number;
  isMobile: boolean;
  showAllSearch: boolean;
  getPopupContainer: Function;
  openAllSearchRef?: any;
  activeFilterPills?: any[];
}

function SearchControls(props: SearchControlsPropsI) {
  const {
    groups,
    form,
    onSubmit,
    onReset,
    numberOfControls,
    isMobile,
    showAllSearch,
    getPopupContainer
  } = props;

  if (!groups || groups.length === 0) return null;

  return (
    <Form>
      <Row
        type="flex"
        justify="center"
        style={{ padding: `${isMobile && "0 10px"}` }}
      >
          <SearchGroups
            onSubmit={onSubmit}
            onReset={onReset}
            form={form}
            groupConfigs={groups}
            numberOfControls={numberOfControls}
            showAllSearch={showAllSearch}
            getPopupContainer={getPopupContainer}
            openAllSearchRef={props.openAllSearchRef}
            activeFilterPills={props.activeFilterPills}
          />
      </Row>
    </Form>
  );
}

SearchControls.defaultProps = {};

export default Form.create({
  // @ts-ignore
  onValuesChange: ({ onValuesChange }, _, allValues) => {
    onValuesChange(allValues);
  }
})(SearchControls);



// WEBPACK FOOTER //
// ./src/components/SearchControls/index.tsx